var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileNotReceived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.637,
    height: 13.302,
    viewBox: "0 0 12.637 13.302",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_34837",
    "data-name": "Path 34837",
    d: "M4.33,3.33v0ZM5.66,9.981H8.1a5.417,5.417,0,0,1,.424-.707,4.8,4.8,0,0,1,.523-.623H5.66Zm0,2.66H7.689q-.033-.333-.033-.665t.033-.665H5.66ZM3,15.3V2H9.651l3.991,3.991V7.52q-.333-.083-.665-.142a3.786,3.786,0,0,0-.665-.058V6.656H8.986V3.33H4.33V13.972H8.1a4.57,4.57,0,0,0,.424.715,5.168,5.168,0,0,0,.523.615Zm9.312-6.651a3.321,3.321,0,0,1,3.326,3.326A3.321,3.321,0,0,1,12.312,15.3a3.321,3.321,0,0,1-3.326-3.326,3.321,3.321,0,0,1,3.326-3.326Zm0,5.321A.426.426,0,1,0,12,13.848.419.419,0,0,0,12.312,13.972Zm-.3-1.264h.6v-.166a.55.55,0,0,1,.1-.325,2.063,2.063,0,0,1,.233-.274,2.3,2.3,0,0,0,.366-.382.864.864,0,0,0,.133-.515,1,1,0,0,0-.316-.774,1.233,1.233,0,0,0-1.505-.066,1.228,1.228,0,0,0-.44.607l.532.233a.711.711,0,0,1,.208-.349.547.547,0,0,1,.39-.15.571.571,0,0,1,.391.125.471.471,0,0,1,.141.374.478.478,0,0,1-.1.308,3.046,3.046,0,0,1-.233.257q-.1.1-.208.2a1.106,1.106,0,0,0-.191.233.989.989,0,0,0-.075.2.935.935,0,0,0-.025.233v.233Z",
    transform: "translate(-3 -2)",
    fill: "#db2727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileNotReceived);
export default __webpack_public_path__ + "static/media/Icon_FileNotReceived.0d0d1fdd49ef52e3b0f4c170df98fecc.svg";
export { ForwardRef as ReactComponent };